import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as TastyBurgerButton from 'vue-tasty-burgers';

Vue.use(TastyBurgerButton);
Vue.prototype.$baseURL = 'https://api.krejsa.xyz/';

require('@/store/subscriber')

axios.defaults.baseURL = Vue.prototype.$baseURL;

Vue.config.productionTip = false

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {

  //Render aplikace probíhá až po dotázání API
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})

//Notion API test
